'use strict';

var capAddressConfig = [];
var paramDataSearchStreet = {};
const callWebService = require('./serverActions/callWebService');
const autocompleteUtil = require('./../utils/autocomplete');
var urlCapAddressConfig = $('#url-cap-address-config').val();
var urlCapAddressSearchAddress = $('#url-cap-address-searchaddress').val();
var capencyHelper = require('capency/capencyHelper');
var base = require('capencyBase/capency/address/function.js');
/// Call Ajax for get All configuration

$.ajax({
    url: urlCapAddressConfig,
    type: 'get',
    async: false,
    dataType: 'json',
    success: function (data) {
        var capConfiguration = data.result;
        capAddressConfig = capConfiguration.length > 0 ? JSON.parse(capConfiguration) : [];
    },
    error: function (err) { }
});

/**
* Populates the zip code field with autocomplete suggestions based on the user's input.
*
* This function fetches locality data from a web service based on the zip code entered by the user.
* It then sets up an autocomplete feature for the zip code input field, allowing users to select
* from a list of suggested localities. Upon selection, it populates the city field and triggers
* further address-related actions.
*
* @async
* @param {Object} configCurrentForm - Configuration object for the current form.
* @param {string} configCurrentForm.zipID - The ID of the zip code input field.
* @param {string} configCurrentForm.cityID - The ID of the city input field.
* @param {string} configCurrentForm.idForm - The ID of the form.
* @param {string} configCurrentForm.addressID_1 - The ID of the first address input field.
* @returns {Promise<void>} - A promise that resolves when the autocomplete setup is complete.
*/
async function dataSourceZipCode(configCurrentForm) {
    var $zipCodeSelector = $('#' + configCurrentForm.zipID);
    var $citySelector = $('#' + configCurrentForm.cityID);
    let $currentCountry = $('#country', '#' + configCurrentForm.idForm);
    let $address1 = $('#' + configCurrentForm.addressID_1);
    var searchResulat = await callWebService.SearchLocality('SearchLocality', $zipCodeSelector.val(), $currentCountry.val());
    if (!searchResulat.error || searchResulat.addresses && searchResulat.addresses.length > 0) {
        var finalDatasource = null;
        finalDatasource = $.map(searchResulat.addresses, function (item) {
            if (item.inputOutput) {
                return {
                    label: item.inputOutput,
                    value: item.postalCode,
                    inputOutput: item.inputOutput,
                    step: item.step,
                    qualityCode: item.qualityCode,
                    localityId: item.localityId,
                    postalCode: item.postalCode,
                    locality: item.locality,
                    localityFlags: item.localityFlags,
                    localitySynonym: item.additionalInfo_7,
                    county: item.localityInfo_3
                };
            }
        });

        $zipCodeSelector.autocomplete({
            create: function () {
                $(this).attr('autocomplete', autocompleteUtil.getAutocompleteValue());
            },
            source: function (request, response) {
                var items = [];

                $.each(finalDatasource, function (key, val) {
                    items.push(val);
                });

                response(items);
            },
            minLength: 0,
            autoFocus: true,
            select: function (event, ui) {
                $(this).next().html(ui.item.inputOutput);
                $(this).removeClass('is-invalid');
                $zipCodeSelector.toggleClass('autocomplete-field-selected', true);
                $citySelector.toggleClass('autocomplete-field-selected', true);

                $('#' + configCurrentForm.cityID).removeClass('is-invalid');
                $('#' + configCurrentForm.addressID_1).focus();

                $(this).attr('data-quality-code', ui.item.qualityCode);

                if (typeof ui.item.localitySynonym !== 'undefined' && ui.item.localitySynonym !== undefined) {
                    ui.item.locality += ' (' + ui.item.localitySynonym + ')';
                }

                $('#' + configCurrentForm.cityID).val(ui.item.locality);

                var dataSearchStreet = {
                    inputOutput: `${ui.item.locality} ${ui.item.postalCode} ${ui.item.inputOutput}`,
                    step: ui.item.step,
                    qualityCode: ui.item.qualityCode,
                    localityId: ui.item.localityId,
                    postalCode: ui.item.postalCode,
                    locality: ui.item.locality,
                    streetNumber: ui.item.streetNumber,
                    localityFlags: ui.item.localityFlags
                };

                capencyHelper.fillZipCodeWithAllCapData($zipCodeSelector, dataSearchStreet);

                paramDataSearchStreet = dataSearchStreet;
                if ($address1.val() !== '') {
                    dataSourceAddress(configCurrentForm, paramDataSearchStreet);
                }
                setTimeout(function () {
                    $('#' + configCurrentForm.addressID_1).focus();
                }, 200);
            }
        }).focus(function () {
            return false;
        });

        if (finalDatasource.length > 0) {
            $zipCodeSelector.autocomplete('search', '');
        }
    } else {
        $(document).trigger('autocomplete:destroy', { element: $zipCodeSelector });
    }
}

/**
* Asynchronously fetches address data based on the provided zip code and updates the form fields with the retrieved data.
*
* @async
* @param {Object} configCurrentForm - Configuration object for the current form.
* @param {string} configCurrentForm.zipID - The ID of the zip code input field.
* @param {string} configCurrentForm.cityID - The ID of the city input field.
* @param {string} configCurrentForm.addressID_1 - The ID of the first address input field.
* @param {string} configCurrentForm.idForm - The ID of the form.
*
* @returns {Promise<void>} - A promise that resolves when the address data has been fetched and the form fields have been updated.
*/
async function dataSourceAddressByZipCode(configCurrentForm) {
    var $zipCodeSelector = $('#' + configCurrentForm.zipID);
    var $citySelector = $('#' + configCurrentForm.cityID);

    var $address1 = $('#' + configCurrentForm.addressID_1);
    var $county = $('input[name$="_stateCode"]');

    var params = {
        inputOutput: $zipCodeSelector.val(),
        step: 'SearchAddressByPostalCode'
    };
    var searchResulat = await callWebService.searchAddressByPostalCode(params);
    if (!searchResulat.error) {
        var finalDatasource = null;
        finalDatasource = $.map(searchResulat.addresses, function (item) {
            if (item.inputOutput) {
                return {
                    label: item.inputOutput,
                    value: item.postalCode,
                    inputOutput: item.inputOutput,
                    step: item.step,
                    qualityCode: item.qualityCode,
                    localityId: item.localityId,
                    postalCode: item.postalCode,
                    locality: item.locality,
                    localityFlags: item.localityFlags,
                    localitySynonym: item.additionalInfo_7,
                    streetNumber: item.streetNumber,
                    streetName: item.streetName,
                    company: item.company,
                    buildingName: item.buildingName,
                    county: item.localityInfo_3
                };
            }
        });

        $zipCodeSelector.autocomplete({
            create: function () {
                $(this).attr('autocomplete', autocompleteUtil.getAutocompleteValue());
            },
            source: function (request, response) {
                var items = [];

                $.each(finalDatasource, function (key, val) {
                    items.push(val);
                });
                response(items);
            },
            minLength: 0,
            change: function () {
                var check = $(this).data('ui-autocomplete') != undefined;
                if (check && $(this).val() !== '') {
                    $zipCodeSelector.autocomplete('search', '');
                }
            },
            autoFocus: false,
            select: function (event, ui) {
                $(this).next().html(ui.item.inputOutput);
                $(this).attr('data-quality-code', ui.item.qualityCode);

                if (typeof ui.item.localitySynonym !== 'undefined' && ui.item.localitySynonym !== undefined) {
                    ui.item.locality += ' (' + ui.item.localitySynonym + ')';
                }

                $('#' + configCurrentForm.cityID).val(ui.item.locality)

                var streetNumber = ui.item.streetNumber ? ui.item.streetNumber + ' ' : '';
                var streetName = ui.item.streetName ? ui.item.streetName + ' ' : '';
                var company = ui.item.company ? ui.item.company + ' ' : '';
                var buildingName = ui.item.buildingName ? ui.item.buildingName + ' ' : '';
                var county = ui.item.county ? ui.item.county : '';
                if (buildingName !== '') {
                    $('input[name$="_address2"]').val(buildingName);
                }

                $address1.val(streetNumber + streetName + company);
                $county.val(county);

                $zipCodeSelector.removeClass('is-invalid');
                $zipCodeSelector.next().css('display', 'none');
                $zipCodeSelector.toggleClass('autocomplete-field-selected', true);

                $citySelector.removeClass('is-invalid');
                $citySelector.toggleClass('autocomplete-field-selected', true);
                $citySelector.next().css('display', 'none');
                $citySelector.focus();

                $address1.removeClass('is-invalid');
                $address1.next().css('display', 'none');

                setTimeout(function () {
                    var address1 = 'input[name$="_address1"]';
                    $('#' + configCurrentForm.addressID_1).focus();

                    if ($('#' + configCurrentForm.addressID_1).length === 0) {
                        $(address1).val(streetNumber + streetName + company);
                    }
                }, 200);
            }
        }).focus(function () {
            if ($(this).val() !== '') {
                $(this).data('uiAutocomplete').search($(this).val());
            }
        });

        var $formSelector = $("form[id='" + configCurrentForm.idForm + "']");

        if ($formSelector.length === 0 && configCurrentForm.idForm === '"dwfrm_address"') {
            $formSelector = '"dwfrm_address"';
        }

        if ($formSelector.length === 0) {
            $formSelector = $("form[name='" + configCurrentForm.idForm + "']");
        }

        $formSelector.on('click', function (event) {
            if (!$(event.target).closest('.ui-autocomplete-input').length && $zipCodeSelector.hasClass('clickedOut')) {
                $('.ui-autocomplete').hide();
                $zipCodeSelector.removeClass('clickedOut');
            }
        });
    }
}

/**
* Populates the city input field with autocomplete suggestions based on the user's input.
*
* This function fetches locality data from a web service and uses it to provide autocomplete
* suggestions for the city input field. It also updates other related fields such as zip code,
* address lines, and county based on the selected city.
*
* @async
* @param {Object} configCurrentForm - Configuration object for the current form.
* @param {string} configCurrentForm.cityID - The ID of the city input field.
* @param {string} configCurrentForm.zipID - The ID of the zip code input field.
* @param {string} configCurrentForm.addressID_1 - The ID of the first address line input field.
* @param {string} configCurrentForm.addressID_2 - The ID of the second address line input field.
* @param {string} configCurrentForm.idForm - The ID of the form containing the input fields.
*
* @returns {void}
*/
async function dataSourceCity(configCurrentForm) {
    var $citySelector = $('#' + configCurrentForm.cityID);
    var $zipCodeSelector = $('#' + configCurrentForm.zipID);
    let $address1 = $('#' + configCurrentForm.addressID_1);
    var $address2 = $('#' + configCurrentForm.addressID_2);
    let $currentCountry = $('#country', '#' + configCurrentForm.idForm);

    var searchResulat = await callWebService.SearchLocality('SearchLocality', $citySelector.val(), $currentCountry.val());
    if (!searchResulat.error || searchResulat.addresses && searchResulat.addresses.length > 0) {
        var finalDatasource = null;
        finalDatasource = $.map(searchResulat.addresses, function (item) {
            if (item.inputOutput) {
                return {
                    label: item.inputOutput,
                    value: item.locality,
                    inputOutput: item.inputOutput,
                    step: item.step,
                    qualityCode: item.qualityCode,
                    localityId: item.localityId,
                    zipCode: item.postalCode,
                    locality: item.locality,
                    localityFlags: item.localityFlags,
                    localitySynonym: item.localitySynonym,
                    streetNumber: item.streetNumber,
                    streetName: item.streetName,
                    company: item.company,
                    buildingName: item.buildingName,
                    county: item.localityInfo_3
                };
            }
        });

        $citySelector.autocomplete({
            create: function () {
                $(this).attr('autocomplete', autocompleteUtil.getAutocompleteValue());
            },
            minLength: 0,
            autoFocus: true,
            source: function (request, response) {
                var items = [];

                $.each(finalDatasource, function (key, val) {
                    items.push(val);
                });

                response(items);
            },
            select: function (event, ui) {
                var currentCountry = $('#currentCountry').val();

                $zipCodeSelector.val(ui.item.zipCode);
                $(this).removeClass('is-invalid');
                $zipCodeSelector.removeClass('is-invalid');
                $zipCodeSelector.toggleClass('autocomplete-field-selected', true);
                $citySelector.toggleClass('autocomplete-field-selected', true);

                setTimeout(function () {
                    $('#' + configCurrentForm.addressID_1).focus();
                }, 200);

                var $county = $('input[name$="_stateCode"]');
                if ($county.length > 0) {
                    $county.val(ui.item.county);
                }

                if (typeof ui.item.localitySynonym !== 'undefined' && ui.item.localitySynonym !== undefined) {
                    ui.item.locality += ' (' + ui.item.localitySynonym + ')';
                }

                var dataSearchStreet = {
                    inputOutput: `${ui.item.locality} ${ui.item.postalCode} ${ui.item.inputOutput}`,
                    step: ui.item.step,
                    qualityCode: ui.item.qualityCode,
                    localityId: ui.item.localityId,
                    postalCode: ui.item.zipCode,
                    locality: ui.item.locality,
                    localityFlags: ui.item.localityFlags,
                    streetNumber: ui.item.streetNumber
                };
                capencyHelper.fillZipCodeWithAllCapData($zipCodeSelector, dataSearchStreet);
                paramDataSearchStreet = dataSearchStreet;
                if ($address1.val() !== '') {
                    dataSourceAddress(configCurrentForm, paramDataSearchStreet);
                }
            }

        }).focus(function () {
            return false;
        });

        if (finalDatasource.length > 0 ) {
            $citySelector.autocomplete('search', '');
        }
    } else {
        $(document).trigger('autocomplete:destroy', {element: $citySelector});
    }
}

/**
* Asynchronously processes and updates address fields based on the provided configuration and search data.
*
* @async
* @param {Object} configCurrentForm - Configuration object containing form element IDs.
* @param {Object} dataSearchStreet - Data object used for searching street addresses.
* @param {string} configCurrentForm.addressID_1 - ID of the primary address input field.
* @param {string} configCurrentForm.addressID_2 - ID of the secondary address input field.
* @param {string} configCurrentForm.cityID - ID of the city input field.
* @param {string} configCurrentForm.zipID - ID of the ZIP code input field.
* @param {string} configCurrentForm.idForm - ID of the form containing the address fields.
* @returns {Promise<void>} - A promise that resolves when the address processing is complete.
*/
async function dataSourceAddress(configCurrentForm, dataSearchStreet) {
    var $addressSelector = $('#' + configCurrentForm.addressID_1);
    var $address2Selector = $('#' + configCurrentForm.addressID_2);
    var $citySelector = $('#' + configCurrentForm.cityID);
    var $zipSelector = $('#' + configCurrentForm.zipID);
    let currentCity = $citySelector.val();
    let currentZip = $zipSelector.val();
    let $currentCountry = $('#country', '#' + configCurrentForm.idForm);
    let additionalOutput = '';

    if (paramDataSearchStreet) {
        [currentCity, dataSearchStreet.postalCode ? dataSearchStreet.postalCode : currentZip].forEach(function (el) {
            if (el) {
                additionalOutput += el + ' ';
            }
        });

        paramDataSearchStreet.inputOutput = additionalOutput + $addressSelector.val();
        paramDataSearchStreet.currentCountry = $currentCountry.val();
        dataSearchStreet = paramDataSearchStreet;
    }

    if (dataSearchStreet.localityFlags === 3) {
        $addressSelector.addClass('has-proposition-false');
    } else {
        $addressSelector.removeClass('has-proposition-false');
    }

    var searchResulat = await callWebService.SearchStreet(dataSearchStreet);

    handleAddress1Input(searchResulat, $addressSelector, $address2Selector, $citySelector, $zipSelector);
    $('#' + configCurrentForm.idForm).off('click').on('click', function (event) {
        if (!$(event.target).closest('.ui-autocomplete-input').length && $addressSelector.hasClass('clickedOut')) {
            $('.ui-autocomplete').hide();
            $addressSelector.removeClass('clickedOut');
        }
    });
}

/**
* Asynchronously builds the data source for address autocomplete functionality.
*
* This function checks if the address input field has an autocomplete UI component initialized.
* If not, it deletes the `inputOutput` property from the `selectedAddress` object and performs a search
* using the `callWebService.searchBuilding` method. The search results are then handled by the `handleAddress2Input` function.
*
* @param {Object} configCurrentForm - Configuration object for the current form, containing address field IDs.
* @param {Object} selectedAddress - The address object selected by the user, which will be used for the search.
* @returns {Promise<void>} A promise that resolves when the data source building process is complete.
*/
async function dataSourceBuilding(configCurrentForm, selectedAddress) {
    var $address2Selector = $('#' + configCurrentForm.addressID_2);
    if (!$address2Selector.data('ui-autocomplete')) {
        delete selectedAddress.inputOutput;
        var searchResult = await callWebService.searchBuilding(selectedAddress);
        handleAddress2Input(searchResult, $address2Selector);
    }
}

/**
* Handles the input for the address1 field by initializing an autocomplete widget
* with the search results and updating related address fields upon selection.
*
* @param {Object} searchResult - The search result object containing address data.
* @param {jQuery} $addressSelector - jQuery object for the address1 input field.
* @param {jQuery} $address2Selector - jQuery object for the address2 input field.
* @param {jQuery} $citySelector - jQuery object for the city input field.
* @param {jQuery} $zipSelector - jQuery object for the zip code input field.
*/
function handleAddress1Input(searchResult, $addressSelector, $address2Selector, $citySelector, $zipSelector) {
    if (searchResult.addresses && searchResult.addresses.length > 0) {
        var finalDatasource = $.map(searchResult.addresses, function (item) {
            if (item.inputOutput) {
                let value = '';
                let formattedDisplayAddress = formatFormattedAddress(item.formattedAddress ? item.formattedAddress : item.inputOutput);
                if (!formattedDisplayAddress) {
                    return;
                }
                value = getAddressValue(item);

                return {
                    label: formattedDisplayAddress,
                    value: value,
                    postalCode: item.postalCode,
                    streetNumber: item.streetNumber,
                    locality: item.locality,
                    localityFlags: item.localityFlags,
                    localitySynonym: item.localitySynonym,
                    inputOutput: item.inputOutput,
                    countryCode: item.countryCode,
                    languageCode: item.languageCode,
                    qualityCode: item.qualityCode,
                    localityId: item.localityId,
                    postalCode: item.postalCode,
                    locality: item.locality,
                    localityFlags: item.localityFlags,
                    streetId: item.streetId,
                    streetName: item.streetName,
                    streetFlags: item.streetFlags,
                    streetType: item.streetType ? item.streetType : '',
                    streetSynonym: item.streetSynonym ? item.streetSynonym : '',
                    streetInfo_1: item.streetInfo_1,
                    streetInfo_2: item.streetInfo_2,
                    streetNumber: item.streetNumber,
                    streetNumberExt: item.streetNumberExt ? item.streetNumberExt : '',
                    step: item.step,
                    buildingName: item.buildingName
                }
            }
        });

        $addressSelector.autocomplete({
            create: function () {
                $(this).attr('autocomplete', autocompleteUtil.getAutocompleteValue());
            },
            source: function (request, response) {
                var items = [];

                $.each(finalDatasource, function (key, val) {
                    items.push(val);
                });
                response(items);
            },
            minLength: 0,
            autoFocus: true,
            select: async function (event, ui) {
                let $this = $(this);
                $this.removeClass('is-invalid');
                $citySelector.removeClass('is-invalid');
                $zipSelector.removeClass('is-invalid');
                $zipSelector.attr('data-quality-code', ui.item.qualityCode);
                $zipSelector.toggleClass('autocomplete-field-selected', true);
                $citySelector.toggleClass('autocomplete-field-selected', true);
                $addressSelector.toggleClass('autocomplete-field-selected', true);

                if (ui.item.localitySynonym) {
                    ui.item.locality += ' (' + ui.item.localitySynonym + ')';
                }

                $(this).next().html(ui.item.inputOutput);

                if (ui.item.localityFlags !== 2) {
                    setTimeout(function () {
                        $citySelector.val(ui.item.locality);
                        $zipSelector.val(ui.item.postalCode);
                        $addressSelector.next().hide();

                        if ($addressSelector.val() && $citySelector.val() && $zipSelector.val()) {
                            capencyHelper.fillZipCodeWithAllCapData($zipSelector, ui.item);
                        }
                    }, 100);
                }
                var objet = {
                    request: 'SearchAddress',
                    inputOutput: ui.item.inputOutput,
                    step: 'CheckStreetNumber',
                    countryCode: ui.item.countryCode,
                    languageCode: ui.item.languageCode,
                    qualityCode: ui.item.qualityCode,
                    localityId: ui.item.localityId,
                    postalCode: ui.item.postalCode,
                    locality: ui.item.locality,
                    localityFlags: ui.item.localityFlags,
                    streetId: ui.item.streetId,
                    streetName: ui.item.streetName,
                    streetFlags: ui.item.streetFlags,
                    streetType: ui.item.streetType,
                    streetSynonym: ui.item.streetSynonym,
                    streetInfo_1: ui.item.streetInfo_1,
                    streetInfo_2: ui.item.streetInfo_2,
                    streetNumber: ui.item.streetNumber,
                    streetNumberExt: ui.item.streetNumberExt,
                    jsoncallback: 'SearchAddress'
                };

                if (ui.item.step === 'CheckStreetNumber') {
                    var currentPostalCode = await base.checkStreetNumber(objet, $zipSelector);
                    if (currentPostalCode !== '' && ui.item.localityFlags !== 2) {
                        setTimeout(function () {
                            $zipSelector.val(currentPostalCode);
                        }, 20);
                    }
                } else if (!ui.item.streetNumber) {
                    objet.inputOutput = '';
                    objet.request = 'SearchLine';
                    objet.jsoncallback = 'SearchLine';
                    var searchResulat = await callWebService.SearchStreetNumber(objet);
                    searchResulat.addresses = typeof (searchResulat.addresses) !== 'undefined' ? searchResulat.addresses.filter(function(address) {
                        return address.streetNumber;
                    }) : [];
                    handleAddress1Input(searchResulat, $addressSelector, $address2Selector, $citySelector, $zipSelector)
                }

                if (ui.item.buildingName) {
                    $address2Selector.val(ui.item.buildingName);
                    $address2Selector.toggleClass('autocomplete-field-selected', true);
                }
                $this.data('selectedAddress', ui.item);
            }
        }).focus(function () {
            return false;
        });

        if (finalDatasource.length > 0) {
            $addressSelector.autocomplete('search', '');
        }
    } else {
        $(document).trigger('autocomplete:destroy', { element: $addressSelector });
    }
}

/**
* Handles the input for the Address2 field by providing autocomplete suggestions based on search results.
*
* @param {Object} searchResult - The result object from the address search API.
* @param {Array} searchResult.addresses - Array of address objects returned from the search.
* @param {string} searchResult.addresses[].buildingName - The name of the building for each address.
* @param {jQuery} $address2Selector - jQuery selector for the Address2 input field.
*
* @returns {void}
*/
function handleAddress2Input(searchResult, $address2Selector) {
    if (searchResult.addresses && searchResult.addresses.length > 0) {
        var finalDatasource = $.map(searchResult.addresses, function (item) {
            if (item.buildingName) {
                return {
                    label: item.buildingName,
                    value: item.buildingName
                }
            }
        });

        $address2Selector.autocomplete({
            create: function () {
                $(this).attr('autocomplete', autocompleteUtil.getAutocompleteValue());
            },
            source: function (request, response) {
                var items = [];

                $.each(finalDatasource, function (key, val) {
                    items.push(val);
                });
                response(items);
            },
            minLength: 0,
            autoFocus: true,
            select: async function (event, ui) {
                let $this = $(this);
                $this.removeClass('is-invalid');
                $this.toggleClass('autocomplete-field-selected', true);

                $(this).next().html(ui.item.inputOutput);

                setTimeout(function () {
                    $address2Selector.next().hide();
                }, 100);
            }
        }).focus(function () {
            return false;
        });

        if (finalDatasource.length > 0) {
            $address2Selector.autocomplete('search', '');
        }
    } else {
        $(document).trigger('autocomplete:destroy', { element: $address2Selector });
    }
}

/**
* Processes the address flow based on the city configuration.
* If the current form configuration contains a "cityID" property, it triggers the data source for the city.
*
* @param {Object} currentFormConfig - The current form configuration object which may contain various properties including "cityID".
* @returns {void}
*/
function callProcessAddressFlowByCity(currentFormConfig) {
    if (currentFormConfig.hasOwnProperty('cityID')) {
        dataSourceCity(currentFormConfig);
    }
}

/**
* Calls the process to search for a street address based on the current form configuration.
* If the form configuration contains the property "addressID_1", it triggers the dataSourceAddress function.
*
* @param {Object} currentFormConfig - The current form configuration object containing address details.
* @returns {void}
*/
function callProcessSearchStreet(currentFormConfig) {
    if (currentFormConfig.hasOwnProperty('addressID_1')) {
        dataSourceAddress(currentFormConfig, {});
    }
}

/**
* Processes the search for a building based on the current form configuration and address data.
* If the current form configuration contains the property "addressID_2", it calls the dataSourceBuilding function.
*
* @param {Object} currentFormConfig - The current form configuration object.
* @param {Object} addressData - The address data object.
* @returns {void}
*/
function callProcessSearchBuilding(currentFormConfig, addressData) {
    if (currentFormConfig.hasOwnProperty('addressID_2')) {
        dataSourceBuilding(currentFormConfig, addressData);
    }
}

/**
* Formats a given address string by replacing pipe characters with commas and trimming leading commas.
*
* @param {string} input - The address string to be formatted.
* @returns {string} - The formatted address string.
*/
function formatFormattedAddress(input) {
    let output = '';
    if (input) {
        output = input.replace(/\|+/g, ', ');

        if (output.startsWith(',')) {
            output = output.substring(2).trim();
        }
    }

    return output;
}

/**
* Constructs a formatted address string based on the position of the street number.
*
* @param {Object} addressItem - The address object containing street details.
* @param {string} addressItem.streetName - The name of the street.
* @param {string} addressItem.streetNumber - The street number.
* @param {string} [addressItem.streetNumberExt] - The optional extension of the street number.
* @param {number} addressItem.streetNumberPosition - The position of the street number (1 or 2).
*
* @returns {string} - The formatted address string.
*/
function getAddressValue(addressItem) {
    // ensure that addressItem attributes are not undefined
    let streetName = addressItem.streetName || '';
    let streetNumber = addressItem.streetNumber || '';
    let streetNumberExt = addressItem.streetNumberExt || '';
    let streetNumberPosition = addressItem.streetNumberPosition || 1;
    if (streetNumberPosition === 2) {
        return [streetName, streetNumber + streetNumberExt].join(' ');
    } else {
        return [streetNumber + streetNumberExt, streetName].join(' ');
    }
}

function callProcessAddressFlow(currentFormConfig) {
    if (currentFormConfig.hasOwnProperty("zipID")) {
        dataSourceZipCode(currentFormConfig);
    }
}

base.callProcessSearchStreet = callProcessSearchStreet;
base.callProcessSearchBuilding = callProcessSearchBuilding;
base.callProcessAddressFlowByCity = callProcessAddressFlowByCity;
base.callProcessAddressFlow = callProcessAddressFlow;

module.exports = base;
